import { CashdrawerFacade } from 'pos/facades';

import { Command } from 'pos/common';

import { Result, SessionProvider, handleServerErrors } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Res, Permission, FlowAction } from 'core/api';
import { Message } from 'core/ui-next/modal';

async function handledRequest<T>(fn: () => Promise<T>): Promise<Result<T>> {
	return await handleServerErrors(fn, {
		onPrintError: async (printError) => {
			await Message.show(Res.Msg.MSG_OPEN_CASH_DRAWER_ERROR(printError.message));
		}
	});
}

declare global {
	interface CommandType {
		openCashDrawer: () => Promise<Result<FlowAction>>
	}
}

Command.register('openCashDrawer', Preconditions.and(Preconditions.ensure(Permission.Cashdrawer_Open), Preconditions.ensureAllowCashTransactions), async (): Promise<Result<FlowAction>> => {
	if (!SessionProvider.getCurrent().AllowCashTransactions) {
		await Message.show(Res.Msg.MSG_CURRENT_POS_DOES_NOT_ALLOW_CASH_TRANSACTIONS());
		return Result.error();
	}

	if (!SessionProvider.getCurrent().HasCashdrawer) {
		await Message.show(Res.Msg.MSG_CURRENT_POS_DOES_NOT_HAS_CASHDRAWER());
		return Result.error();
	}

	await handledRequest(CashdrawerFacade.openCashdrawer);

	return Result.ok(SessionProvider.getCurrent().AfterOpenCashdrawerAction);
});
